(function () {
	/*
	Swurvey Services
	*/
	"use strict";

	angular.module("swurveys.common")
		.factory("utilsService", Handler)

	function Handler(swurveysStageConfig) {
    var utilsService = {};

    utilsService.rotate = function ($el, deg, speed) {
    	$el.css({
    		"transition": (speed || 0) + "s",
    		"-webkit-transform": "rotate(" + deg + "deg)",
    		"-moz-transform": "rotate(" + deg + "deg)",
    		"-ms-transform": "rotate(" + deg + "deg)",
    		"-o-transform": "rotate(" + deg + "deg)",
    		"transform": "rotate(" + deg + "deg)"
    	});
    };

    utilsService.getSwurveysLogoURL = function() {
        var backgroundColor = $(".viewer")
            .css("background-color");

        var rgb = backgroundColor.split('(')[1].split(')')[0].split(",");

        var o = Math.round(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) / 1000);

        if(o > 125) {
            return "images/swurveyslogo_s_b.png";
        } else {
            return "images/swurveyslogo_s_w.png";
        }
    }

    utilsService.loadScript = function (src, callback) {

    	var script = document.createElement("script");
    	script.type = "text/javascript";
    	script.src = src;
    	script.async = true;
    	if(callback) script.onload = callback;

    	document.getElementsByTagName("head")[0].appendChild(script);
    };

    utilsService.cleanUpStyle = function (freeStyle, disabled) {
    	if(!freeStyle) {
    		freeStyle = $("style#free-style")[0].sheet;
    	}

    	freeStyle.disabled = disabled;

    	if(freeStyle.cssRules.length > 0) {
    		for(var i = 0; i < freeStyle.cssRules.length; i++) {
    			freeStyle.deleteRule(freeStyle.cssRules[i]);
    		}
    	}
    };

    utilsService.CSSArrayFromJSONChildren = function (jsonChildren) {
    	var css = [];
    	for(var key in jsonChildren) {
    		if(jsonChildren.hasOwnProperty(key)) {
    			css.push(key + " { " + CSSJSON.toCSS(jsonChildren[key]) + " }");
    		}
    	}
    	return css;
    };

    utilsService.applyStyleOverrides = function (model) {
        if(model.classOverrides) {
            if(model.classOverrides.add) {
                angular.forEach(model.classOverrides.add, function (value, key) {
                    value.forEach(function (style) {
                        console.log(key, style);
                        console.log($(key));
                        $(key)
                            .addClass(style);
                    });
                });
            }
            if(model.classOverrides.remove) {
                angular.forEach(model.classOverrides.remove, function (value, key) {
                    value.forEach(function (style) {
                        console.log(key, style);
                        $(key)
                            .removeClass(style);
                    });
                });
            }
        }
    };

    utilsService.getAllCardTypes = function (model) {
        var classes = [];
        model.cards.forEach(function (card) {
            if(classes.indexOf(card.type) == -1) {
                classes.push(card.type);
            }
        });
        return classes;
    };

    utilsService.makeFeedback = function (cards, data) {
		var responses = data.Responses;
		var res = {};
		var feedback = [];

		console.log(data);

		if (!cards || !data || data.errorMessage) {
			return 0;
		}

		cards.forEach(function (card, index, array) {
			if (card && responses && responses[card.id]) {
				var thisCardsResponses = responses[card.id];
				var inverted = _.invert(thisCardsResponses);
				var topResponseRate = _.max(thisCardsResponses);
				var topResponseDirection = inverted[topResponseRate];
				feedback.push({
					question: "<b>" + card.text + "</b>",
					answer: card[topResponseDirection].choice.toString(),
					count: topResponseRate
				});
			}
		}, feedback);

		//Just pick one and put that on the card

		var sampleResponse = _.sample(feedback);

		console.log("Sample Response:", sampleResponse);

		var totalResponseCount = data.TotalResponseCount;

		if (!sampleResponse) {
			sampleResponse = { count: 0 };
		}

		sampleResponse.percentage = ((sampleResponse.count / totalResponseCount) * 100)
			.toFixed(0);

		return sampleResponse;
    };

    utilsService.makeResponse = function (cards) {
    	var response = {};
    	cards.forEach(function (element, index, array) {
    		if(element.answer && element.id) {
    			response[element.id] = element.answer.direction;
    		}
    	}, response);

    	return response;
    };

    utilsService.makeSummary = function (cards, fun, isPreview) {
    	var summaries = [];
    	cards.forEach(function (element, index, array) {
    		if(isPreview && element.sumText) {

    			summaries.push(fun(element.sumText.replace(/===/, "<b>===</b>")));

    		} else if(element.answer && element.sumText) {
    			summaries.push(fun(element.sumText.replace(/===/, "<b>" + element.answer.sumText + "</b>")));
    		}
    	}, summaries);
    	return summaries;
    };

    //Used to generate Swurvey id
    utilsService.generateUUID = function (removeDashes) {
    	var d = new Date()
    		.getTime();
    	var uuid = 'Axxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    		var r = (d + Math.random() * 16) % 16 | 0;
    		d = Math.floor(d / 16);
    		return(c == 'x' ? r : (r & 0x3 | 0x8))
    			.toString(16);
    	});
    	if(removeDashes) {
    		uuid = uuid.replace(/-/g, "");
    	}
    	return uuid;
    };

    utilsService.getQueryParameterByName = function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    utilsService.gotoDashboard = function (uid) {
        window.location.hash = "#/d/" + uid;
    }

    utilsService.bindEventHandler = function (eventName, handler) {
        window.addEventListener(eventName, handler);
    }

	utilsService.defaultText = {
		leadGen: "Like our content? Enter your email address to join our newsletter.",
		extendedFeedback: "Have more to say? Please leave your comments below.",
		referralCard: "Would you like to signup to make your own Swurveys?"
	}

	utilsService.getOpenGraphLink = function (swurveyId, userToken) {
		return swurveysStageConfig.getConfigPropertyValue("public_api_endpoint") + "/api/swurveys/" + swurveyId + "/opengraph?userToken=" + userToken;
	}

	utilsService.getNoAuthResponsesLink = function (swurveyId) {
		return swurveysStageConfig.getConfigPropertyValue("api_endpoint") + "/api/swurveys/" + swurveyId + "/responses/noauth";
	}


    //These are valid swipe directions, NOT valid 'choices'
	utilsService.questionTypes = {
		binary: ['left', 'right'],
		three: ['left', 'right', 'bottom'],
		four: ['left', 'right', 'bottom', 'top'],
		slider: ['left', 'right', 'bottom', 'top']
	};


	utilsService.getQuestionCardTypes = function () { return Object.keys(utilsService.questionTypes); };


    //Given a model, generate an empty response object.  This is used on the analytics page, and, specifically for billboard preview
	utilsService.generateBlankResponse = function(model) {
		var questionTypes = utilsService.getQuestionCardTypes();
		console.log("question types", questionTypes)

		var responses = {};

		for(var card in model.cards)
		{

			if(questionTypes.indexOf(card.type) >= 0)
			{
				var response = {};
				switch (card.type) {
					//4 and 3-way cascade down as they are supersets of what's below
					case "four":
					  response.top = 0;
					case "three":
				      response.bottom = 0;
					case "binary":
				      response.left = 0;
				      response.right = 0;
						break;
					case "slider":
					  response.one = 0;
					  response.two = 0;
					  response.three = 0;
					  response.four = 0;
					  response.five = 0;
				}
				responses[card.id] = response;
			}
		}
		return responses;
	}



	return utilsService;

	}
}());
